module.exports = __webpack_public_path__ + "static/assets/d48ffeabb5073f52a22ba417438e8ff4.png";